import React from "react";
import { AuthUserContext } from "../../providers/AuthProvider";
import { useNavigate } from "react-router-dom";
import firebase from "../../firebase/firebase"
import LockIcon from "@mui/icons-material/Lock"
import EditIcon from "@mui/icons-material/Edit";
import { Alert, GlobalStyles } from "@mui/material";
import {
  Container,
  Button,
  Typography,
  Grid,
  Box,
  Stack,
  TextField,
} from "@mui/material";
import PostActivity from "../../helpers/post-activity";

const ProfileSettings = () => {
  const navigate = useNavigate();
  const { user, profile, setProfile } = React.useContext(AuthUserContext);
  const [updateStatus, setUpdateStatus] = React.useState("")
  const [editing, setEditing] = React.useState(false)
  const [newName, setNewName] = React.useState(user?.displayName)
  const oldName = user?.displayName
  const handleChange = (e)=>{
    setNewName(e.target.value)
  }
  const handleSubmit = async (e) => {
      e.preventDefault();
      try{
        await user.updateProfile({displayName: newName})
        setProfile({...profile, name: newName}) //for instant change
        const usersRef = firebase.firestore().collection('users').doc(profile.id);
        await usersRef.update({name: newName})
        await PostActivity({
          text: 'You successfully updated your profile.',
          uid: profile.uid,
          createdBy:profile?.uid
        })
      }catch(e){
        setUpdateStatus(e.message)
        // alert(JSON.stringify(e, null, 2));
      }
      setEditing(false)
  }
  return (
    <>
      <GlobalStyles
        styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
      />
      <Container maxWidth="lg" component="main" >
        <Box sx={{pt: 7, pl: 2 }}>
          <Typography
            align="left"
            variant="h4"
            color="text.primary"
            fontWeight="600"
            component="p"
          >
            Profile
          </Typography>
          {updateStatus && <Alert severity='error'>{updateStatus}</Alert>}
          <br />
          {editing ? <>
          </> 
          : <>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              variant="body"
              color="text.primary"
              fontSize="24px"
              fontWeight="600"
              component="p"
              sx={{ mt:5 }}
            >
              Personal Details
            </Typography>
            <Button
              variant="outlined"
              sx={{ fontWeight: 400, width: 145, height: 33, textTransform:"none", fontFamily:"ABeeZee" }}
              color="primary"
              startIcon={<EditIcon />}
              
              onClick={(e)=> setEditing(true) }
            >
              Edit Info
            </Button>
          </Stack>
          </>}
              <Box
                onSubmit={handleSubmit}
                component="form"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mb: 2,
                  mt: 6,
                  flexDirection: "column",
                }}
              >
                <Grid container spacing={8}>
                  <Grid item xs={10}>
                    {editing 
                    ? <>
                    <Typography  fontSize="24px" fontWeight="600" align="left">Edit your name</Typography>
                    <TextField
                    color="info"
                    label={"Full Name"}
                    onChange={handleChange}
                    value={newName}
                    name="name" variant="outlined" sx={{width:'100%', mt:5}}/>
                    </>  
                    : <>
                    <Grid container spacing={10}><Grid item>
                    <Typography  fontSize="16px" fontWeight="600" align="left">Your name</Typography></Grid>
                    <Grid item>
                    <Typography  fontSize="16px" fontWeight="600" align="left" sx={{font: "#363636"}}>{user?.displayName}</Typography></Grid>
                    </Grid>
                    </>}
                  </Grid>

                  <Grid item xs={10}>
                    <Grid container spacing={10}><Grid item>
                    <Typography  fontSize="16px" fontWeight="600" align="left">Your email</Typography></Grid>
                    <Grid item>
                    <Typography fontSize="16px" fontWeight="600" align="left" sx={{color: '#363636'}}>{user?.email}</Typography></Grid>
                    </Grid> 
                  </Grid>

                  {profile?.userType === 'admin' &&
                    <Grid item xs={10}>
                      <Grid container spacing={10}><Grid item>
                        <Typography  fontSize="16px" fontWeight="600" align="left">Phone number</Typography></Grid>
                        <Grid item>
                          <Typography fontSize="16px" fontWeight="600" align="left" sx={{color: '#363636'}}>{user?.phoneNumber}</Typography></Grid>
                      </Grid>
                    </Grid>

                  }
                  
                
                  
                  
                  <Grid item xs={10}>
                    <Grid
                        align="left"
                        container
                         direction="row"
                         justifyContent="flex-start"
                         alignItems="center"
                         >
                        <Grid item xs={2}>
                            <Typography fontSize="24px" fontWeight="600">Password</Typography>
                        </Grid>      
                        <Grid item xs={4}>
                            <Button 
                            sx={{width:238, height:43, textTransform:"none"}}
                            fontSize="16px" fontWeight="400"
                            variant="outlined" 
                            startIcon={<LockIcon/>}
                            onClick={(e) => navigate(`/${profile?.userType !== 'artist' ? profile?.userType : 'artists'}/password-settings`)}
                            >
                                Change password
                            </Button>
                        </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={10}>
                    <Grid
                         container
                         direction="row"
                         justifyContent="center"
                         alignItems="center"
                         >
                       {editing &&
                        <>
                       <Grid item xs={4}>
                            <Button 
                            sx={{width:238, height:43, textDecoration:"underline"}}
                            fontSize="16px" fontWeight="400"
                            color="primary"
                            disabled={!editing}
                            onClick={(e) => {setEditing(false)
                              setNewName(user?.displayName)}}
                              >
                               Quit Without Saving
                            </Button>
                        </Grid>
                        <Grid item xs={4}>
                        <Button
                            sx={{width: 170, height:43, fontSize: 16, fontWeight:400, backgroundColor:'#FD4A01',textTransform:"none" }} disabled={oldName===newName} type='submit' variant={'contained'} color={'warning'}
                            >Save Changes</Button>
                        </Grid>      
                            </>
                            }
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
        </Box>
      </Container>
    </>
  );
};

export default ProfileSettings;